export const MAX_TERM_NAME_LENGTH = 100;
export const MAX_CUSTOM_PROPERTY_OPTION_LENGTH = 100;
export const MAX_LONG_TEXT_PROPERTY_LENGTH = 400;
export const MAX_DESCRIPTION_LENGTH = 1000;

export enum Theme {
    LIGHT = 'light',
    DARK = 'dark',
    HIGHLIGHT = 'highlight',
    TOOLTIP = 'tooltip',
    HELP = 'help'
}

export enum LayoutDirection {
    COLUMN = 'column',
    ROW = 'row'
}

export enum LayoutJustification {
    START = 'start',
    CENTER = 'center',
    END = 'end'
}
